import React from 'react';
import { City } from '../../services/city.service';

interface CityCardsProps {
  cities: City[];
  onCitySelect: (cityName: string) => void;
}

const CityCards: React.FC<CityCardsProps> = ({ cities, onCitySelect }) => {
  return (
    <div className="my-3">
      <h3 className="text-sm font-medium text-xervix-text-muted dark:text-xervix-text-muted-dark mb-2">
        Selecciona una ciudad:
      </h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {cities.map((city) => (
          <button
            key={city.id}
            onClick={() => onCitySelect(city.name)}
            className="py-2 px-3 bg-xervix-bg-tertiary dark:bg-xervix-bg-tertiary-dark hover:bg-xervix-primary hover:text-white rounded-md transition-colors text-sm text-left"
          >
            {city.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CityCards;
